import { render, staticRenderFns } from "./JointFrames.vue?vue&type=template&id=0be7cedd"
import script from "./JointFrames.vue?vue&type=script&lang=ts"
export * from "./JointFrames.vue?vue&type=script&lang=ts"
import style0 from "./JointFrames.vue?vue&type=style&index=0&id=0be7cedd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports